import * as routes from 'Routes/routesConstants'

export const path = {
  tracker: `${routes.trackNow}${routes.jobDescription}/:userId`
}
